module.exports = __webpack_public_path__ + "img/task_top@2x.07d88a31.png";